window.customFunction = [];

window.customFunction['Customer'] = require('./customers/customer-methods');

window.customFunction['Deviation'] = require('./deviations/deviations-methods');
